import React, {Component} from "react";
import * as echarts from "echarts";
import {useEffect} from "react";

const ChartTrending = ({dataChart}) => {
  useEffect(() => {
    let chartDom = document.getElementById("main");
    let myChart = echarts.init(chartDom);
    let option;

    option = {
      title: {
        text: "Trend Container",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        data: ["Total Container"],
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: dataChart.data.trend_container.map((item) => item.tahun_trayek), 
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: "Total Container",
          type: "line",
          stack: "Total",
          data: dataChart.data.trend_container.map((item) => item.total_container),
          label: {
            show: true,
            position: 'top'
          },
        },
      ],
    };
    option && myChart.setOption(option);
  }, []);

  return <div id="main" style={{width: "100%", height: "410px", padding: 10}}></div>;
};

export default ChartTrending;
